
import React, { CSSProperties } from 'react';

import colors from '../constants/colors';

export interface IAsteriskProps {
    style?: CSSProperties
}

const Asterisk: React.FC<IAsteriskProps> = (props) => {
    return (
        <span style={{
            ...{
                color: "red"
            }, ...props.style
        }}>*</span>
    );
}

export default Asterisk
export { Asterisk }